module.exports = __webpack_public_path__ + "img/banner.e70281f1.png";